import { render } from "./preview-proforma-invoice.vue?vue&type=template&id=538977d5"
import script from "./preview-proforma-invoice.vue?vue&type=script&lang=js"
export * from "./preview-proforma-invoice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__